import React from "react";
import OffersFormBreadCrumb from "../../Components/Offer/CreateOffer/OffersFormBreadCrumb";
import OffersFormCreate from "../../Components/Offer/CreateOffer/OffersFormCreate";

export default function OffersForm() {
  return (
    <React.Fragment>
      <div className="page-content pb-0">
        <OffersFormBreadCrumb />
        <OffersFormCreate />
      </div>
    </React.Fragment>
  );
}
